module.exports = __webpack_public_path__ + "static/media/sala_principal_4.f8b7734a.jpg";